const VIEW = 'ORGANISATION'

export const STATE_INIT = VIEW+'_STATE_INIT'
export const VIEW_MOUNT = VIEW+'_VIEW_MOUNT'
export const VIEW_UNMOUNT = VIEW+'_VIEW_UNMOUNT'
